import { createSlice } from '@reduxjs/toolkit';
import { IParamountData } from '../interfaces';
import { set } from 'react-hook-form';

const initialState: IParamountData = {
  tenants: [],
  products: [],
  timelines: [],
  segments: [],
  attributes: [],
  strategies: [],
  experiments: [],
  selectedTenet: '',
  triggers: []
};

const ParamountSlice = createSlice({
  name: 'Paramount',
  initialState,
  reducers: {
    setTenants(state, action) {
      state.tenants = action.payload;
    },
    setProducts(state, action) {
      state.products = action.payload;
    },
    setTimelines(state, action) {
      state.timelines = action.payload;
    },
    setSegments(state, action) {
      state.segments = action.payload;
    },
    setAttributes(state, action) {
      state.attributes = action.payload;
    },
    setStrategies(state, action) {
      state.strategies = action.payload;
    },
    setExperiments(state, action) {
      state.experiments = action.payload;
    },
    setSelectedTenet(state, action) {
      state.selectedTenet = action.payload;
    },
    setTriggers(state, action) {
      state.triggers = action.payload;
    }
  }
});
export const {
  setTenants,
  setProducts,
  setTimelines,
  setSegments,
  setAttributes,
  setStrategies,
  setExperiments,
  setSelectedTenet,
  setTriggers
} = ParamountSlice.actions;

export default ParamountSlice.reducer;
